import { useRef } from "react";
import { ReaderTheme } from "../../../hooks/useReaderSettings";

interface ReaderToolbarProps {
  theme: ReaderTheme;
  accentColor: string;
  onThemeToggle: () => void;
  onAccentChange: (color: string) => void;
}

export default function ReaderToolbar({
  theme,
  accentColor,
  onThemeToggle,
  onAccentChange,
}: ReaderToolbarProps) {
  const colorRef = useRef<HTMLInputElement>(null);

  const isDark = theme === "dark";

  return (
    <div
      className={`flex items-center gap-2 mb-6 pb-4 border-b ${
        isDark ? "border-[#1a1a1a]" : "border-[#e8e0d4]"
      }`}
    >
      {/* Theme toggle */}
      <button
        onClick={onThemeToggle}
        title={isDark ? "Switch to Light Mode" : "Switch to Dark Mode"}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
          isDark
            ? "bg-[#1e1e1e] text-[#aaa] hover:text-white border border-[#2e2e2e]"
            : "bg-[#f0ebe3] text-[#555] hover:text-[#1a1a1a] border border-[#ddd5c8]"
        }`}
      >
        <i className={isDark ? "ri-sun-line" : "ri-moon-line"} />
        {isDark ? "Light Mode" : "Dark Mode"}
      </button>

      {/* Color picker */}
      <button
        onClick={() => colorRef.current?.click()}
        title="Choose accent color"
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
          isDark
            ? "bg-[#1e1e1e] text-[#aaa] hover:text-white border border-[#2e2e2e]"
            : "bg-[#f0ebe3] text-[#555] hover:text-[#1a1a1a] border border-[#ddd5c8]"
        }`}
      >
        <span
          className="w-3 h-3 rounded-full flex-shrink-0"
          style={{ backgroundColor: accentColor }}
        />
        Accent Color
        <input
          ref={colorRef}
          type="color"
          value={accentColor}
          onChange={(e) => onAccentChange(e.target.value)}
          className="sr-only"
          aria-label="Choose accent color"
        />
      </button>

      {/* Hint */}
      <span
        className={`text-xs ml-auto hidden sm:block ${
          isDark ? "text-[#333]" : "text-[#bbb5aa]"
        }`}
      >
        Tap any verse to highlight · <i className="ri-edit-2-line" /> to add a note
      </span>
    </div>
  );
}
